import React, { useEffect, useState } from 'react';
import { getIcon } from '@flybits/design-system';
import { animated } from '@react-spring/web';
import { useTransition } from 'react-spring';
import './LoadingIcon.scss';

interface Props {
  width?: number;
  height?: number;
  className?: string;
  text?: string;
  type?: string;
  fullScreen?: boolean;
  visible?: boolean;
}

const LoadingIcon = (props: Props) => {
  const { type, width, height, className, fullScreen, visible, text } = props;
  const [show, setVisibility] = useState(false);
  const transitions = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 250 },
  });
  useEffect(() => {
    setVisibility(visible || false);
  }, [visible]);

  const loadingBlock = (height = 16) => (
    <div
      className="content-placeholder-text"
      role="progressbar"
      style={{ ['--block-height' as string]: `${height}px` }}
    >
      <span className="content-placeholder-background"></span>
    </div>
  );
  const loadingIcon =
    !type || type === 'circle' ? getIcon('loading', { width, height, className }) : loadingBlock(height);
  return (
    <>
      {transitions((style, item) =>
        item ? (
          <animated.div
            style={style as any}
            className={`loading__icon_wrapper loading__icon_wrapper_${
              !type || type === 'circle' ? 'circle' : 'block'
            } ${fullScreen ? 'fullscreen' : ''}`}
          >
            {loadingIcon}
            {text && <h3>{text}</h3>}
          </animated.div>
        ) : null,
      )}
    </>
  );
};

export default LoadingIcon;
